import { render, staticRenderFns } from "./PrkSubHeading.vue?vue&type=template&id=15f11630&scoped=true&"
import script from "./PrkSubHeading.vue?vue&type=script&lang=js&"
export * from "./PrkSubHeading.vue?vue&type=script&lang=js&"
import style0 from "./PrkSubHeading.vue?vue&type=style&index=0&id=15f11630&scoped=true&lang=scss&"
import style1 from "./PrkSubHeading.vue?vue&type=style&index=1&id=15f11630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f11630",
  null
  
)

export default component.exports